import { render } from "./ProfileImageUploader.vue?vue&type=template&id=22befa29"
import script from "./ProfileImageUploader.vue?vue&type=script&lang=js"
export * from "./ProfileImageUploader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\staff.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__